import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

import { SnackbarComponent } from "./snackbar/snackbar.component";

@NgModule({
	imports: [TranslateModule, CommonModule],
	declarations: [SnackbarComponent],
})
export class ToastModule {}
